import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { LoaderService } from 'src/app/service/loader.service';
import { CommonService } from 'src/app/service/common.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { RolesEnum } from 'src/app/service/enums/role.enum';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-delay-order',
  templateUrl: './delay-order.component.html',
  styleUrls: ['./delay-order.component.scss']
})
export class DelayOrderComponent extends BaseComponent implements OnInit {
    dtOptions: any = {};
    ordersList: any[];
    searchText: string;

    private datatableElement: DataTableDirective;
    @ViewChild('dtElement') table: ElementRef;
  
    chartData: number[]=[];
    public barChartLabelsDelay:string[] =[]
    public barChartDataDelay:any[] =[];
    public barChartColorsDelay:Array<any> = [];
    public barChartType:string = 'horizontalBar';
    public barChartLegend:boolean = false;
  //   public barChartOptions:any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };
    public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 6,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };
 constructor(private commonService: CommonService,
             private loaderService: LoaderService,
            ) { super(); }

  ngOnInit(): void {

    const that = this;
    this.barChartDataDelay =[];
    this.barChartLabelsDelay=[];
    this.barChartDataDelay=[];
      this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      lengthMenu: [10, 50, 100, 1000],
      serverSide: true,
      processing: true,
      search: {
        return: true
      },
      searchDelay: 500,
      order: [[0, "desc"]],
      dom: 'lBfrtip',
      columns: [
        { orderable: true },
        { orderable: true },       
        { orderable: true, },
        { orderable: true, },
        { orderable: true, },
        { orderable: true, },
        { orderable: true, },
      ],
      language: {
        url: 'assets/datatable-i18n/' + that.appTranslateService.getCurrentLang() + '.json'
      },
      buttons: [
        // {
        //   text: that.appTranslateService.getTranslate(''),
        //   key: '1',
        //   className: 'datatable-export-excel-btn',
        //   action: function (e, dt, node, config) {
        //     that.rerender();
        //   }
        // },
        {
          text: that.appTranslateService.getTranslate('exportExcel'),
          key: '2',
          className: 'datatable-export-excel-btn',
          action: function (e, dt, node, config) {
           that.exportToExcel();
          }
        },
       
      ],
       ajax: (dataTablesParameters: any, callback) => {
        
        that.commonService.GetDelayOrdersList(dataTablesParameters).subscribe(
          res => {
            if (res.successed) {
              this.ordersList =  res.data.data.delayOrderTable;
               this.chartData=[];
               this.barChartLabelsDelay=[];
                console.log( res.data.data);
                
              // alert( res.data.data.Delays.length);0
                for (let i = 0; i <  res.data.data.delayEmployeeWise.length; i++) {

                    this.barChartColorsDelay=[{backgroundColor:'#92be8eff'}] ;
                    this.barChartLabelsDelay.push(res.data.data.delayEmployeeWise[i].employeeName)
                    this.chartData.push(res.data.data.delayEmployeeWise[i].workCount)
                } 
                this.barChartDataDelay=[{data:this.chartData,label:this.lang==="en"? "Delay":"المتأخر"}];
               

              callback({
                recordsTotal: res.data.recordsTotal,
                recordsFiltered: res.data.recordsFiltered,
                data: []
              });
              that.loaderService.hide();
            }
            else {
              that.loaderService.hide();
              that.toastrAlertService.errorToastr(res.errorMessage);
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
          },
          error => {
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
            that.loaderService.hide();
            if (typeof error.error !== "undefined") {
              that.toastrAlertService.errorToastr(that.appTranslateService.getTranslate(error.error));
            }
          }
        )

      }
     
    };

  }


    exportToExcel() {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, this.appTranslateService.getTranslate("orders"));
      /* save to file */
      XLSX.writeFile(wb, this.appTranslateService.getTranslate("orders") + '.xlsx');
    }

  public chartClicked(e:any):void {
        //console.log(e);
      }
  
    public chartHovered(e:any):void {
        console.log(e);
      }
    goToOrderDetails(order) {
        if (order.createdBy === this.userprofile.id || order.userId === this.userprofile.id || this.userProfileService.isRoleExists(RolesEnum.SuperAdmin)|| this.userProfileService.isRoleExists(RolesEnum.Repaid)) {
          // this.router.navigate(["/order/orderDetails/" + order.requestId]);
          window.open("/order/orderDetails/" + order.requestId);
        }
      }
  
    rerender() {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.ajax.reload();
      });
    } 
}
